import { useDictionary } from "@adamlip/okeoke.client"
import Icon from "assets/icons"
import { AppParamsContext } from "contexts/AppParamsContext"
import { useContext } from "react"

export default function ListElement({ name, iconName, onClick }) {
  const { appParams } = useContext(AppParamsContext)
  const { getValue } = useDictionary()

  const coloredIcons = appParams?.styles?.moreMenu?.coloredIcons
  const capitalize = appParams?.styles?.fonts?.capitalize
  const style = appParams?.styles?.moreMenu?.style
  const moreMenuElements = appParams?.styles?.moreMenu

  const colors = {
    languages: "bg-purple-500/20",
    locations: "bg-purple-500/20",
    morelocations: "bg-purple-500/20",
  }
  const iconColors = {
    languages: "fill-purple-500",
    locations: "fill-purple-500",
    morelocations: "fill-purple-500",
  }
  if (moreMenuElements?.[name] == null || moreMenuElements?.[name] === false)
    return null
  return (
    <div
      className={`cursor-pointer flex text-lg items-center gap-2 ${
        capitalize ? "uppercase" : ""
      } ${style === "grid" ? "flex-col" : "flex-row"}`}
      onClick={() => onClick(name)}
    >
      <div
        className={
          coloredIcons
            ? `p-2  rounded-lg ${colors?.[name] || "bg-primary/20"}`
            : "p-2 bg-primary/20 rounded-lg"
        }
      >
        <div className="w-6 h-6">
          <Icon
            name={iconName}
            className={"stroke-primary"}
            secondClassName={
              coloredIcons
                ? iconColors?.[name] || "fill-primary"
                : "fill-primary"
            }
          />
        </div>
      </div>
      <div
        className={`flex flex-col text-center ${
          style === "grid" ? "w-[76px]" : ""
        } leading-none`}
        style={{ fontSize: style === "grid" ? "12px" : "18px" }}
      >
        {getValue(`app_v2_${name}_accordionHeaderLabel`)}
      </div>
    </div>
  )
}
